module.exports = __webpack_public_path__ + "img/ahorcadoNuevo5.2e516be4.png";